<template>
  <b-dropdown
    no-caret
    size="sm"
    variant="light"
    toggle-class="radius"
    :disabled="options.length <= 1"
  >
    <template #button-content>
      <div class="d-flex flex-direction-row">
        <div class="dropdown-content">{{ options[index] || "" }}</div>
        <b-icon-chevron-down class="my-auto" />
      </div>
    </template>
    <b-dropdown-item v-for="(label, index) of options" :key="index" @click="onClick(index)">{{
      label
    }}</b-dropdown-item>
  </b-dropdown>
</template>

<style scoped lang="scss">
// とりあえず、ダイアログのxlサイズ基準で省略を考える
.dropdown-content {
  @media screen and (max-width: 991px) {
    max-width: 6em;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>

<script lang="ts">
import { defineComponent, ref, watch, type PropType } from "vue";
export default defineComponent({
  name: "dropdown",
  props: {
    // 外部からの指定
    activeIndex: { type: Number, default: 0 },
    options: { type: Array as PropType<string[]>, default: () => [] },
  },
  setup(props, { emit }) {
    const index = ref(0);

    watch(
      () => props.activeIndex,
      () => {
        if (index.value !== props.activeIndex) {
          index.value = props.activeIndex;
        }
      }
    );

    const onClick = (i: number): void => {
      index.value = i;
      emit("click", i);
    };

    return { index, onClick };
  },
});
</script>
